import { useQuery } from '@tanstack/react-query'
import { fetchDistrictsByNation } from '@/services/districts'

export function useDistrictsByNation(nationId: string | undefined) {
  const districtsQuery = useQuery({
    queryKey: ['districts', 'nation', nationId],
    queryFn: () => fetchDistrictsByNation(nationId!),
    enabled: !!nationId,
  })

  return {
    districts: districtsQuery.data,
    isLoading: districtsQuery.isLoading,
    error: districtsQuery.error,
  }
}
